import { render, staticRenderFns } from "./TrustedDevice.vue?vue&type=template&id=3f20a6e6&scoped=true&"
import script from "./TrustedDevice.vue?vue&type=script&lang=js&"
export * from "./TrustedDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20a6e6",
  null
  
)

export default component.exports